import React from "react";
import { Button, List, Popover, Badge } from "antd";
import { ReloadOutlined } from "@ant-design/icons";
import { IconBell, IconNotification } from "@tabler/icons-react";
import useGetApi from "../../hooks/useGetApi";
import usersApis from "../../api/methods/users";
import moment from "moment";
import appColors from "../../theme/common/colors";

interface Notification {
  id: number;
  avatar: string;
  content: string;
  created_at: string;
}

const AppNotifications: React.FC = () => {
  const {
    data: unreadNotifications,
    isLoading,
    refetch,
  } = useGetApi(usersApis().getUnreadNotifications);
  let notifications = unreadNotifications?.results || [];

  const handleRefresh = () => {
    refetch();
  };

  const content = (
    <div className="p-0 bg-white rounded-lg w-[340px] max-h-[500px] overflow-y-auto">
      <div className="flex justify-between items-center mb-1 px-2">
        <h2 className="text-xl font-medium">Notifications</h2>
        <Button
          type="link"
          icon={<ReloadOutlined spin={isLoading} />}
          onClick={handleRefresh}
        ></Button>
      </div>
      <List
        loading={isLoading}
        itemLayout="horizontal"
        dataSource={notifications}
        renderItem={(item: Notification) => (
          <List.Item>
            <List.Item.Meta
              avatar={
                <div className="p-3 bg-[#f5f5f5] rounded-[100px]">
                  <IconNotification color={appColors.primary} />
                </div>
              }
              title={<p className="font-medium">{item?.content}</p>}
              description={moment(item.created_at).format("MM/DD/YYYY hh:mm A")}
            />
          </List.Item>
        )}
      />
    </div>
  );

  return (
    <Popover content={content} trigger="click">
      <Button type="text">
        <Badge count={notifications.length}>
          <IconBell strokeWidth={1.3} />
        </Badge>
      </Button>
    </Popover>
  );
};

export default AppNotifications;
